module.exports = __webpack_public_path__ + "img/search.9302c304.svg";